


































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Contact } from '@/api/model/contact'
import { ContactAPI } from '@/api/backend-client'
import { escapeHtml } from '@/helpers/html'

@Component
export default class ContactDetails extends Vue {
    @Prop({required: true}) readonly contact!: Contact
    @Prop({type: Boolean, default: false}) readonly canEdit!: boolean
    modalEditContact: boolean = false
    modalEditContactSpouse: boolean = false
    submittingEditContact: boolean = false

    async updateContact(onComplete: () => {}) {
        this.submittingEditContact = true

        try {
            await ContactAPI.update(this.contact.id, this.contact)
            // @todo: instead of editing the "live" record, copy it and edit that
            // @todo: then once complete, replace the referral contact
            // @todo: should feel more robus for the user, since now pressing cancel still shows the changes.
            onComplete()

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.submittingEditContact = false
        }
    }
}
